export enum FilterCategory {
  STATE = 'State',
  THERAPY_OR_PSYCHIATRY = 'Therapy or psychiatry',
  INSURANCE = 'Insurance',
  SPECIALTY = 'Concerns',
  GENDER_PREFERENCE = 'Gender',
  TREATMENT_APPROACH = 'Treatment approach',
  TYPE_OF_SERVICE = 'Type of service',
  SESSION_FORMAT = 'Video or in-person',
  AGE_GROUP_TREATED = 'Age group treated',
  // Admin directory only, from here down.
  LICENSURE = 'Licensure',
  LANGUAGE = 'Language',
  ETHNICITY = 'Provider race/ethnicity',
  LGBT_IDENTIFIED = 'Provider identifies as LGBTQIA+'
}
